import { IoTimeOutline } from 'react-icons/io5'
import { IoIosCheckmarkCircleOutline } from 'react-icons/io'
import { RxCrossCircled } from 'react-icons/rx'

export const REQUEST_STATUS = Object.freeze({
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
})
export const REQUEST_TAB_STATUS = Object.freeze({
  PENDING: { key: 1, name: 'common.pending', eventKey: 'pending' },
  APPROVED: { key: 2, name: 'common.approved', eventKey: 'approved' },
  REJECTED: { key: 3, name: 'common.rejected', eventKey: 'rejected' },
})
export const eventKeyToKeyMap = Object.fromEntries(
  Object.entries(REQUEST_TAB_STATUS).map(([key, value]) => [
    value.eventKey,
    value.key,
  ]),
)
export const Tabs = [
  {
    key: REQUEST_TAB_STATUS.PENDING.key,
    eventKey: REQUEST_TAB_STATUS.PENDING.eventKey,
    title: REQUEST_TAB_STATUS.PENDING.name,
    icon: <IoTimeOutline size={20} />,
    disabled: false,
    tooltip: REQUEST_TAB_STATUS.PENDING.name,
  },
  {
    key: REQUEST_TAB_STATUS.APPROVED.key,
    eventKey: REQUEST_TAB_STATUS.APPROVED.eventKey,
    title: REQUEST_TAB_STATUS.APPROVED.name,
    icon: <IoIosCheckmarkCircleOutline size={20} />,
    disabled: false,
    tooltip: REQUEST_TAB_STATUS.APPROVED.name,
  },
  {
    key: REQUEST_TAB_STATUS.REJECTED.key,
    eventKey: REQUEST_TAB_STATUS.REJECTED.eventKey,
    title: REQUEST_TAB_STATUS.REJECTED.name,
    icon: <RxCrossCircled size={20} />,
    disabled: false,
    tooltip: REQUEST_TAB_STATUS.REJECTED.name,
  },
]
